
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ], gameStatus = "idle", score = 0){
        // eslint-disable-next-line no-console
        console.log(initialState);
        this.gameStatus = gameStatus;
        this.currentState = structuredClone(initialState);
        this.score = score;
        this.initialState = structuredClone(initialState);
    }
    moveLeft() {
        let moved = false;
        for(let i = 0; i < this.currentState.length; i++){
            const row = this.currentState[i];
            let filteredRow = row.filter((num)=>num !== 0);
            for(let j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                filteredRow[j] *= 2;
                this.score += filteredRow[j];
                if (filteredRow[j] === 2048) this.gameStatus = "win";
                filteredRow[j + 1] = 0;
                moved = true;
            }
            filteredRow = filteredRow.filter((num)=>num !== 0);
            while(filteredRow.length < 4)filteredRow.push(0);
            if (!filteredRow.every((num, idx)=>num === row[idx])) moved = true;
            this.currentState[i] = filteredRow;
        }
        if (moved) {
            this.addRandomTile();
            this.checkGameOver();
            return true;
        }
    }
    moveRight() {
        let moved = false;
        for(let i = 0; i < this.currentState.length; i++){
            const row = this.currentState[i];
            let filteredRow = row.filter((num)=>num !== 0);
            for(let j = filteredRow.length - 1; j > 0; j--)if (filteredRow[j] === filteredRow[j - 1]) {
                filteredRow[j] *= 2;
                this.score += filteredRow[j];
                if (filteredRow[j] === 2048) this.gameStatus = "win";
                filteredRow[j - 1] = 0;
                moved = true;
            }
            filteredRow = filteredRow.filter((num)=>num !== 0);
            while(filteredRow.length < 4)filteredRow.unshift(0);
            if (!filteredRow.every((num, idx)=>num === row[idx])) moved = true;
            this.currentState[i] = filteredRow;
        }
        if (moved) {
            this.addRandomTile();
            this.checkGameOver();
            return true;
        }
    }
    moveUp() {
        this.currentState = this.transpose(this.currentState);
        const moved = this.moveLeft();
        this.currentState = this.transpose(this.currentState);
        return moved;
    }
    moveDown() {
        this.currentState = this.transpose(this.currentState);
        const moved = this.moveRight();
        this.currentState = this.transpose(this.currentState);
        return moved;
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.currentState;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.gameStatus;
    }
    /**
   * Starts the game.
   */ start() {
        this.gameStatus = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.currentState = structuredClone(this.initialState);
        this.score = 0;
        this.gameStatus = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    addRandomTile() {
        const emptyTiles = [];
        for(let i = 0; i < this.currentState.length; i++){
            for(let j = 0; j < this.currentState[i].length; j++)if (this.currentState[i][j] === 0) emptyTiles.push([
                i,
                j
            ]);
        }
        const randomIndex = Math.floor(Math.random() * emptyTiles.length);
        const [row, col] = emptyTiles[randomIndex];
        this.currentState[row][col] = Math.random() < 0.9 ? 2 : 4;
    }
    transpose(matrix) {
        const transposed = [];
        for(let col = 0; col < matrix[0].length; col++){
            const newRow = [];
            for(let row = 0; row < matrix.length; row++)newRow.push(matrix[row][col]);
            transposed.push(newRow);
        }
        return transposed;
    }
    checkGameOver() {
        for(let row = 0; row < this.currentState.length; row++)for(let col = 0; col < this.currentState[row].length; col++){
            if (this.currentState[row][col] === 0) return false;
        }
        for(let row = 0; row < this.currentState.length - 1; row++)for(let col = 0; col < this.currentState[row].length - 1; col++){
            if (this.currentState[row][col] === this.currentState[row][col + 1]) return false;
            if (this.currentState[row][col] === this.currentState[row + 1][col]) return false;
        }
        this.gameStatus = "lose";
        return true;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


"use strict";
const $09e991522ca7e64e$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($a5fd07fa01589658$exports)))();
const $09e991522ca7e64e$var$startButton = document.querySelector(".start.button");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
let $09e991522ca7e64e$var$startX = 0;
let $09e991522ca7e64e$var$startY = 0;
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
        $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    } else {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.replace("start", "restart");
        $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    }
    $09e991522ca7e64e$var$updateGameField();
});
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
function $09e991522ca7e64e$var$updateGameField() {
    const state = $09e991522ca7e64e$var$game.getState();
    for(let i = 0; i < state.length; i++)for(let j = 0; j < state[i].length; j++){
        const cell = $09e991522ca7e64e$var$gameField.rows[i].cells[j];
        const value = state[i][j];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add(`field-cell--${value}`);
    }
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
    if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
}
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    let moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
    }
    if (moved) $09e991522ca7e64e$var$updateGameField();
});
document.addEventListener("touchstart", (e)=>{
    const touch = e.touches[0];
    $09e991522ca7e64e$var$startX = touch.clientX;
    $09e991522ca7e64e$var$startY = touch.clientY;
});
document.addEventListener("touchend", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    const touch = e.changedTouches[0];
    const endX = touch.clientX;
    const endY = touch.clientY;
    const diffX = endX - $09e991522ca7e64e$var$startX;
    const diffY = endY - $09e991522ca7e64e$var$startY;
    const absX = Math.abs(diffX);
    const absY = Math.abs(diffY);
    // мінімальна довжина свайпу
    if (Math.max(absX, absY) < 30) return;
    let moved = false;
    if (absX > absY) // горизонтальний свайп
    moved = diffX > 0 ? $09e991522ca7e64e$var$game.moveRight() : $09e991522ca7e64e$var$game.moveLeft();
    else // вертикальний свайп
    moved = diffY > 0 ? $09e991522ca7e64e$var$game.moveDown() : $09e991522ca7e64e$var$game.moveUp();
    if (moved) $09e991522ca7e64e$var$updateGameField();
});


//# sourceMappingURL=index.b9f4acc7.js.map
